import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { MOCK_DB_UPDATED_EVENT, getQueryKeysForCollection, type MockDbUpdatedDetail } from '../../mocks/mockDbSync';

/**
 * Listens for `mockDbUpdated` events (dispatched by `window.TPH.insertMockRecord()` /
 * `updateMockIncidentReport()` in `src/mocks/browser.ts`) and invalidates the
 * React Query keys associated with the impacted mock IndexedDB collection, so
 * console-driven mock edits show up without a manual refetch or reload.
 */
export function useMockDbSync() {
    const queryClient = useQueryClient();

    useEffect(() => {
        function handleMockDbUpdated(event: CustomEvent<MockDbUpdatedDetail>) {
            getQueryKeysForCollection(event.detail.collection).forEach((queryKey) => {
                queryClient.invalidateQueries({ queryKey });
            });
        }

        window.addEventListener(MOCK_DB_UPDATED_EVENT, handleMockDbUpdated as EventListener);
        return () => window.removeEventListener(MOCK_DB_UPDATED_EVENT, handleMockDbUpdated as EventListener);
    }, [queryClient]);
}
